import React from "react";
import Network from "./components/Network";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Network />
    </div>
  );
}

export default App;
